import React from 'react'
import './Powerbar.scss'

export default function Powerbar({ teamOneName, teamTwoName, teamOneWinPercentage, teamTwoWinPercentage, drawPercentage, teamOneColor, teamTwoColor}) {
    if (teamOneWinPercentage + teamTwoWinPercentage + drawPercentage !== 1) {
        return null;
    }

    return (
        <div className="powerbar">
            <div className="labels">
                {teamOneWinPercentage !== 0 && (
                    <div className="percentage">
                        <div>{teamOneName}</div>
                        <div>{Number(teamOneWinPercentage * 100).toFixed() + '%'}</div>
                    </div>
                )}
                {drawPercentage !== 0 && (
                    <div className="percentage">
                        <div>Draw</div>
                        <div>{Number(drawPercentage * 100).toFixed() + '%'}</div>
                    </div>
                )}
                {teamTwoWinPercentage !== 0 && (
                    <div className="percentage">
                        <div>{teamTwoName}</div>
                        <div>{Number(teamTwoWinPercentage * 100).toFixed() + '%'}</div>
                    </div>
                )}
            </div>
            <div className="bar">
                <div style={{
                    backgroundColor: teamOneColor,
                    width: (teamOneWinPercentage * 100) + '%',
                }}/>
                <div style={{
                    backgroundColor: 'white',
                    width: (drawPercentage * 100) + '%',
                }}/>
                <div style={{
                    backgroundColor: teamTwoColor,
                    width: (teamTwoWinPercentage * 100) + '%',
                }}/>
            </div>
        </div>
    )
}
